module.exports = __webpack_public_path__ + "738779c2fa5a394df6186b81d16fc8ed.svg";